module.exports = __webpack_public_path__ + "static/media/romulo.c3c0dac5.png";